module.exports = __webpack_public_path__ + "img/1f41d.b4ddc43.svg";